import { NgModule } from '@angular/core';
import { HomepageComponent } from '@app/contentful';
import {
  CmsConfig,
  FeaturesConfig,
  PageMetaConfig,
  provideConfig,
  SiteContextConfig,
  StateConfig,
  StateTransferType,
} from 'haba-core';
import { CheckoutConfig } from 'haba-featurelibs/checkout/root';
import { layoutConfig, mediaConfig, PWAModuleConfig } from 'haba-storefrontlib';
import { StockInformationComponent } from 'src/app/product/product-detail/stock-information/stock-information.component';
import { customLayoutConfig } from 'src/app/spartacus/customLayoutConfig';
import { ErrorPageComponent } from '../contentful/error-page/error-page.component';
import { habaI18nConfig } from './i18n.config';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(customLayoutConfig),
    provideConfig(mediaConfig),
    provideConfig(<SiteContextConfig>{
      context: {},
    }),
    provideConfig(habaI18nConfig),
    provideConfig(<FeaturesConfig>{
      features: {
        level: '4.1',
      },
    }),
    provideConfig(<PageMetaConfig>{
      pageMeta: {
        canonicalUrl: {
          forceTrailingSlash: false,
        },
      },
    }),
    provideConfig(<CheckoutConfig>{
      checkout: {
        guest: true,
        express: true,
      },
    }),
    provideConfig({
      routing: {
        routes: {
          wishlist: { paths: ['wishlist'] },
          notAvailable: { paths: ['not-available'] },
          styleguide: { paths: ['styleguide'] },
        },
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        FormFieldsModule: {
          module: () => import('@app/base-components').then((m) => m.FormFieldsModule),
        },
        StyleguideModule: {
          module: () =>
            import('src/app/@styleguide/styleguide.module').then((m) => m.StyleguideModule),
        },
      },
    }),
    provideConfig(<PWAModuleConfig>{
      pwa: {
        enabled: false,
      },
    }),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ContentfulComponent: {
          component: HomepageComponent,
        },
        StockNotificationComponent: {
          component: StockInformationComponent,
        },
        ErrorPageComponent: {
          component: ErrorPageComponent,
        },
      },
    }),
    provideConfig(<StateConfig>{
      state: {
        ssrTransfer: {
          keys: {
            product: StateTransferType.EXCLUDE_STATE,
          },
        },
      },
    }),
  ],
})
export class SpartacusConfigurationModule {}
